/* unplugin-vue-components disabled */import { render } from "./StandardSpeachCard.vue?vue&type=template&id=4e011434&scoped=true&ts=true"
import script from "./StandardSpeachCard.vue?vue&type=script&lang=ts"
export * from "./StandardSpeachCard.vue?vue&type=script&lang=ts"

import "./StandardSpeachCard.vue?vue&type=style&index=0&id=4e011434&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e011434"]])

export default __exports__